'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { Page as PageWrapper } from 'src/components/Organisms/Page';
export function ResetPage(t0) {
  const $ = _c(3);
  const {
    reset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1>Something went wrong!</h1>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== reset) {
    t2 = <PageWrapper><div>{t1}<button onClick={reset}>Try again</button></div></PageWrapper>;
    $[1] = reset;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}